// extracted by mini-css-extract-plugin
export default {"addCoupon":"add-coupon_addCoupon__3ExJL","title":"add-coupon_title__Q7aUr","codeAndPin":"add-coupon_codeAndPin__YsOmN","footer":"add-coupon_footer__RFCfb"};